/* globals Front */
(function($) {
	'use strict';
	$.fn.Slide__Comments = function() {
		this.each(function() {

			/*
			 * Action: Do comments -- Add / Remove
			 */
      const $self = $(this);

      // Async actions
			if( $.Body.hasClass('loaded') ) {
				setTimeout( function() {

					// Scroll to the bottom of the div
					$self.find(".comments").animate({ scrollTop: $self.find(".comments").prop("scrollHeight")}, 1000);

				}, 1 );
			} else {

				$.Window.on('load.app', function() {
					// Scroll to the bottom of the div
					$self.find(".comments").animate({ scrollTop: $self.find(".comments").prop("scrollHeight")}, 1000);
				});

			}




			// *****************************************
			// Elements
			const $comments = $self.find('.comments'),
				$form = $self.find('form.new-comment'),
				$input = $form.find('.comment-text');


			// *****************************************
			// Create new comments
			$input.on('focus', function() {
				// Disable keyboard shortcuts
				$.Globals.disable_keyboard = true;
			}).on('blur', function() {
				$.Globals.disable_keyboard = false;
			}).on('keydown', function(e) {

				// Disable input
				if( $input.hasClass('temp') ) e.preventDefault(); // <= .temp temporarily disables the field while submitting

				// Listen for enter to submit
				if( e.keyCode === 13 ) {
					if( e.shiftKey ) return true;
					$form.submit();
					return false;
				}

			});

			// If popup (not list view) trigger focus()
			if( $self.hasClass('popup') ) $input.focus();

			// Form listener
			$form.removeClass('off').off( 'submit.comment-create' ).on( 'submit.comment-create', function(e) {
				e.preventDefault();

				const options = {
					cid: $self.data('cid'),
					sid: $self.data('sid'),
					comment_text: $input[0].innerText,
				};

				// Input field
				$input.addClass('temp');

				$.Globals.ajax_post( 'comment_create', options, function( response ) {

					if( response.success ) {

						// Build new comment html
						const comment = response.data.comment,
							$new_comment = $('<div class="comment">' +
							'<div class="content">' +
								'<span class="owner">' + comment.owner_display_name + '</span> <span class="text">' + comment.text + '</span>' +
							'</div>' +
							'<div class="details">' + comment.human_date + '</div>' +
							'<a href="" class="comment-delete ir" data-comid="' + comment.id + '" data-cid="' + comment.collection_id + '" data-sid="' + comment.slide_id + '" data-oid="' + comment.owner_id + '" title="' + Front.translations.delete + '">' +
								Front.translations.delete +
							'</a>' +
						'</div>');

						// Append new comment
						$comments.append( $new_comment );

						// Scroll to the bottom again
						setTimeout( function() {
							$comments.animate({ scrollTop: $comments.prop("scrollHeight")}, 1000);

							// Add listener to delete
							$new_comment.find('.comment-delete').off( $.Globals.clickEvent ).on( $.Globals.clickEvent, _do_delete);
						},1);

						// Reset comment input
						$input.removeClass('temp').html('');

					} else {

						console.warn( response );

					}

				});

			});


			// *****************************************
			// Delete comments
			const _do_delete = function(e) {
				e.preventDefault();

				const $this = $(this),
					$comment = $this.closest('.comment'),
					comment_id = $this.data('comid'),
					collection_id = $this.data('cid'),
					slide_id = $this.data('sid'),
					owner_id = $this.data('oid'),
					options = {
						comid: comment_id,
						cid: collection_id,
						sid: slide_id,
						oid: owner_id,
					};

				// Let the user know we are deleting this
				$comment.addClass('temp');

				$.Globals.ajax( 'scspaces_comment_delete', options, function( response ) {
					console.log(response);
					if( response.success ) {

						// Set static height for animation
						$comment.height( $comment.height() );

						setTimeout( () => { // <= Async after dom write
							$comment.css({'height':0,'margin-bottom':-1});

							setTimeout( () => { // <= After animation
								$comment.remove();
							}, 1000 );
						}, 1 );
					} else {
						console.warn( response );
					}
				});

			};
			$comments.find('.comment-delete').off( $.Globals.clickEvent ).on( $.Globals.clickEvent, _do_delete);


		});
		return this;
	};
}(jQuery));
